import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { FC } from "react";
import {
    createBrowserRouter,
    Outlet,
    RouterProvider,
    ScrollRestoration,
} from "react-router";
import { BugsnagErrorBoundaryWrapper } from "./bugsnag-error-boundary-wrapper";
import { ResumeBuilderProvider } from "./context";
import { Layout } from "./layout";
import { ResumeIntroPage } from "./resume-intro";
import { ResumePreviewPage } from "./resume-preview";
import { ResumeSentPage } from "./resume-sent";
import { ResumeBuilder1Page } from "./resume-step-1";
import { ResumeBuilder2Page } from "./resume-step-2";
import { ResumeBuilder3Page } from "./resume-step-3";

const queryClient = new QueryClient({
    defaultOptions: {
        mutations: { retry: false },
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

const Root: FC = () => {
    return (
        <>
            <ScrollRestoration />
            <Outlet />
        </>
    );
};

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                index: true,
                element: <ResumeIntroPage />,
            },
            {
                path: "step1",
                element: <ResumeBuilder1Page />,
            },
            {
                path: "step2",
                element: <ResumeBuilder2Page />,
            },
            {
                path: "step3",
                element: <ResumeBuilder3Page />,
            },
            {
                path: "preview",
                element: <ResumePreviewPage />,
            },
            {
                path: "sent",
                element: <ResumeSentPage />,
            },
        ],
    },
]);

function App() {
    return (
        <BugsnagErrorBoundaryWrapper>
            <QueryClientProvider client={queryClient}>
                <ResumeBuilderProvider>
                    <Layout>
                        <RouterProvider router={router} />
                    </Layout>
                </ResumeBuilderProvider>
            </QueryClientProvider>
        </BugsnagErrorBoundaryWrapper>
    );
}

export default App;
